/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Services
 ---------------------------------------------------------- */

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import Navigation from '../modules/_navigation.js'
import ObjectFit from '../modules/_object-fit.js'
import Print from '../modules/_print.js'
import SelectChoices from '../modules/_select-choices.js'
import StepGuide from '../modules/_step-guide'
import LazyLoad from '../modules/_lazy-load'
import TestimonialSlider from '../modules/_testimonial-slider'
import VideoModal from '../modules/_video-modal'
import CoachesSlider from '../modules/_coaches-slider'
import SmoothScroll from '../modules/_smooth-scroll'
import AutofillForm from '../modules/_autofill-form'
import Modal from '../modules/_modal.js'
import BMICalculator from '../modules/_bmi-calculator.js'
import CF from '../modules/_cf'
import Consent from '../modules/_consent.js'

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
const app = window.app = new Application(window.options || {})

/* Register modules
 ---------------------------------------------------------- */
app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(SelectChoices)
app.use(StepGuide)
app.use(LazyLoad)
app.use(TestimonialSlider)
app.use(VideoModal)
app.use(CoachesSlider)
app.use(SmoothScroll)
app.use(AutofillForm)
app.use(Modal)
app.use(BMICalculator)
app.use(CF)
app.use(Consent)



// WEBPACK FOOTER //
// ./resources/js/public/main.js